import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { captureCampaignParams } from './lib/campaignParams';

// Apply theme override before first paint, mirroring useTheme's logic.
(() => {
  try {
    const stored = localStorage.getItem('hbs_theme');
    if (stored === 'light' || stored === 'dark') {
      document.documentElement.setAttribute('data-theme', stored);
    }
  } catch {
    // localStorage unavailable — fall through to prefers-color-scheme.
  }
})();

// Record ?src / ?promo before React mounts. AuthGuard's redirect to /auth drops
// the query string, so anything not captured here is gone by the time AuthPage
// or a subscribe CTA could read it.
captureCampaignParams();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
